import { Flex, Image, Skeleton } from "antd";
import { useEffect } from "react";
import { ArquivoAnexoModel } from "../../../../models/arquivoAnexo/arquivoAnexoModel";
import { listarArquivoAnexo } from "../../../../services/arquivoAnexoService";
import { pdfLogo } from "../../../../util/assets/pdf_logo";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { openPdfInNewTab } from "../../../../util/functions/openPdf";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";

const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png"];

const VisualizarArquivos = () => {
  //estados globais
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);
  const arquivoAnexoState = useAppSelector((state) => state.arquivoAnexo);

  //hooks
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(listarArquivoAnexo(contaFinanceiraState.entity.id));
  }, [contaFinanceiraState.entity]);

  return (
    <Flex gap={12} vertical>
      {arquivoAnexoState.loading ? (
        <Flex gap={12} vertical>
          <Skeleton.Button block active />
          <Skeleton.Button active block style={{ height: 200 }} />
        </Flex>
      ) : (
        <Flex gap={12} vertical>
          <p>VALOR: {contaFinanceiraState.entity.valorBruto ? currencyBRL(contaFinanceiraState.entity.valorBruto) : "-"}</p>
          {arquivoAnexoState.list.map((a: ArquivoAnexoModel) => {
            const isPdf = a.caminhoArquivo?.toLowerCase().endsWith(".pdf");
            return (
              <div
                key={a.id}
                style={{
                  border: "1px solid",
                  padding: "24px",
                  borderRadius: "20px",
                  width: "200px",
                  height: "200px",
                  cursor: isPdf ? "pointer" : !ALLOWED_EXTENSIONS.some((text) => a.caminhoArquivo?.toLowerCase().endsWith(text)) ? "pointer" : "default",
                }}
                onClick={() => {
                  if (isPdf) {
                    openPdfInNewTab(a.caminhoArquivo ?? "");
                  } else {
                    if (!ALLOWED_EXTENSIONS.some((text) => a.caminhoArquivo?.toLowerCase().endsWith(text))) {
                      window.open(a.caminhoArquivo ?? "", "_blank");
                    }
                  }
                }}
              >
                {!isPdf && ALLOWED_EXTENSIONS.some((text) => a.caminhoArquivo?.toLowerCase().endsWith(text)) && <Image height={150} width={150} src={a.caminhoArquivo ?? undefined} />}
                {isPdf && <Image preview={false} height={150} src={pdfLogo} />}
                {!isPdf && !ALLOWED_EXTENSIONS.some((text) => a.caminhoArquivo?.toLowerCase().endsWith(text)) && <Image preview={false} height={150} width={150} src={pdfLogo} />}
              </div>
            );
          })}
        </Flex>
      )}
    </Flex>
  );
};

export default VisualizarArquivos;
